"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enlargeAnimation = void 0;
const react_1 = require("react");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_2 = require("react");
const xorBy_1 = __importDefault(require("lodash/xorBy"));
const classnames_1 = __importDefault(require("classnames"));
const framer_motion_1 = require("framer-motion");
const TableType_1 = __importDefault(require("../PageLoading/TableType"));
const Checkbox_1 = __importDefault(require("../Checkbox"));
const TableButtons_1 = __importDefault(require("./TableButtons"));
const ExpandButton_1 = __importDefault(require("./ExpandButton"));
const table_module_scss_1 = __importDefault(require("./table.module.scss"));
const Table = (_a) => {
    var { className, headers, rows, buttons, isLoading, checkedRows, onCheckRow, expandedRows, onExpandRow, withExpandAllButton } = _a, props = __rest(_a, ["className", "headers", "rows", "buttons", "isLoading", "checkedRows", "onCheckRow", "expandedRows", "onExpandRow", "withExpandAllButton"]);
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(TableType_1.default, {}, void 0);
    }
    const headersArr = Object.entries(headers);
    const withButtons = Array.isArray(buttons) && buttons.length > 0;
    const withCheckboxes = Array.isArray(checkedRows);
    const withExpandableRows = Array.isArray(expandedRows) && typeof onExpandRow === 'function';
    const colSpan = headersArr.length + [withButtons, withExpandableRows, withCheckboxes].filter(Boolean).length;
    const { rowsWithEnableddCheckbox, rowsWithExtraContent } = rows.reduce((acc, row) => {
        if (!row.disableCheckbox) {
            acc.rowsWithEnableddCheckbox.push(row);
        }
        if (row.extraContent) {
            acc.rowsWithExtraContent.push(row);
        }
        return acc;
    }, {
        rowsWithExtraContent: [],
        rowsWithEnableddCheckbox: []
    });
    const areAllCheckboxesChecked = !!checkedRows &&
        checkedRows.length > 0 &&
        checkedRows.length === rowsWithEnableddCheckbox.length;
    const areAllRowsExpanded = !!expandedRows && expandedRows.length > 0 && expandedRows.length === rowsWithExtraContent.length;
    const isExpandAllButtonDisabled = rows.some(({ disableExpand }) => disableExpand);
    const isCheckAllDisabled = rowsWithEnableddCheckbox.length === 0 || rows.length === 0;
    const handleCheckAllRowsChange = (e) => {
        if (checkedRows) {
            onCheckRow === null || onCheckRow === void 0 ? void 0 : onCheckRow(e.target.checked ? rowsWithEnableddCheckbox : []);
        }
    };
    const handleExpandAllRowsClick = () => {
        onExpandRow === null || onExpandRow === void 0 ? void 0 : onExpandRow(!areAllRowsExpanded ? rows.filter(row => !!row.extraContent) : []);
    };
    const isRowChecked = ({ id }) => {
        return !!(checkedRows === null || checkedRows === void 0 ? void 0 : checkedRows.some(row => row.id === id));
    };
    const isRowExpanded = ({ id }) => {
        return !!(expandedRows === null || expandedRows === void 0 ? void 0 : expandedRows.some(row => row.id === id));
    };
    const handleCheckRowChange = (row) => (e) => {
        if (checkedRows) {
            onCheckRow === null || onCheckRow === void 0 ? void 0 : onCheckRow(e.target.checked
                ? [...checkedRows, row]
                : checkedRows.filter(checkedRow => checkedRow.id !== row.id));
        }
    };
    const handleExpandRowClick = (row) => () => {
        onExpandRow === null || onExpandRow === void 0 ? void 0 : onExpandRow((0, xorBy_1.default)(expandedRows, [row], 'id'));
    };
    const tableHeadRow = headersArr.reduce((acc, [key, value], index, arr) => {
        acc.push((0, jsx_runtime_1.jsx)("th", Object.assign({ className: table_module_scss_1.default.table_thead_th }, { children: value }), key));
        if (index + 1 === arr.length) {
            if (withButtons) {
                acc.push((0, jsx_runtime_1.jsx)("th", Object.assign({ className: table_module_scss_1.default.table_thead_th }, { children: "\u00A0" }), "buttons"));
            }
            if (withExpandableRows) {
                acc.unshift((0, jsx_runtime_1.jsx)("th", Object.assign({ className: table_module_scss_1.default.table_thead_th }, { children: withExpandAllButton ? ((0, jsx_runtime_1.jsx)(ExpandButton_1.default, { isExpanded: areAllRowsExpanded, disabled: isExpandAllButtonDisabled, onClick: handleExpandAllRowsClick }, void 0)) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "\u00A0" }, void 0)) }), "expand-buttons"));
            }
            if (withCheckboxes) {
                acc.unshift((0, jsx_runtime_1.jsx)("th", Object.assign({ className: table_module_scss_1.default.table_thead_th }, { children: (0, jsx_runtime_1.jsx)(Checkbox_1.default, { id: "checkAll", disabled: isCheckAllDisabled, checked: areAllCheckboxesChecked, onChange: handleCheckAllRowsChange }, void 0) }), "checkAll"));
            }
        }
        return acc;
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: table_module_scss_1.default.table_wrapper }, { children: (0, jsx_runtime_1.jsxs)("table", Object.assign({ className: (0, classnames_1.default)(className, table_module_scss_1.default.table) }, props, { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", { children: tableHeadRow }, void 0) }, void 0), (0, jsx_runtime_1.jsx)("tbody", { children: Array.isArray(rows) && rows.length > 0 ? (rows.map((row, i) => {
                        const isExpanded = isRowExpanded(row);
                        return ((0, jsx_runtime_1.jsxs)(react_2.Fragment, { children: [(0, jsx_runtime_1.jsxs)("tr", Object.assign({ className: table_module_scss_1.default.table_tbody_tr }, { children: [withCheckboxes && ((0, jsx_runtime_1.jsx)("td", Object.assign({ className: table_module_scss_1.default.table_tbody_td }, { children: (0, jsx_runtime_1.jsx)(Checkbox_1.default, { id: `checkbox-${row.id}`, disabled: !!row.disableCheckbox, checked: isRowChecked(row), onChange: handleCheckRowChange(row) }, void 0) }), "Checkbox")), withExpandableRows && ((0, jsx_runtime_1.jsx)("td", Object.assign({ className: table_module_scss_1.default.table_tbody_td }, { children: row.extraContent && ((0, jsx_runtime_1.jsx)(ExpandButton_1.default, { isExpanded: isExpanded, disabled: !!row.disableExpand, onClick: handleExpandRowClick(row) }, void 0)) }), `expand-button-${row.id}`)), headersArr.map(([header], i) => {
                                            var _a;
                                            return ((0, jsx_runtime_1.jsx)("td", Object.assign({ className: table_module_scss_1.default.table_tbody_td }, { children: (_a = row[header]) !== null && _a !== void 0 ? _a : '-' }), i));
                                        }), withButtons && ((0, jsx_runtime_1.jsx)("td", Object.assign({ className: table_module_scss_1.default.table_tbody_td }, { children: (0, jsx_runtime_1.jsx)(TableButtons_1.default, { row: row, buttons: buttons }, void 0) }), "buttons"))] }), void 0), (0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { children: isExpanded && row.extraContent && ((0, react_1.createElement)(framer_motion_1.motion.tr, Object.assign({}, exports.enlargeAnimation, { className: (0, classnames_1.default)('table-extraContent-row', table_module_scss_1.default.table_tbody_tr), key: `extraContent-${row.id}` }),
                                        (0, jsx_runtime_1.jsx)("td", Object.assign({ className: table_module_scss_1.default.table_tbody_td, colSpan: colSpan }, { children: row.extraContent }), void 0))) }, void 0)] }, i));
                    })) : ((0, jsx_runtime_1.jsx)("tr", Object.assign({ className: table_module_scss_1.default.table_tbody_tr }, { children: (0, jsx_runtime_1.jsx)("td", Object.assign({ className: (0, classnames_1.default)('text-center', table_module_scss_1.default.table_tbody_td), colSpan: colSpan }, { children: "There is no data to display" }), void 0) }), void 0)) }, void 0)] }), void 0) }), void 0));
};
exports.default = Table;
exports.enlargeAnimation = {
    initial: 'hidden',
    animate: 'visible',
    exit: 'hidden',
    variants: {
        hidden: {
            opacity: 0,
            y: -5
        },
        visible: {
            opacity: 1,
            y: 0
        }
    },
    transition: {
        duration: 0.1,
        ease: 'easeOut'
    }
};
